"use strict";

var _defineProperty = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/defineProperty.js").default;
exports.TimestampSecondsParser = void 0;
var _index = require("../../../constructFrom.js");
var _Parser = require("../Parser.js");
var _utils = require("../utils.js");
class TimestampSecondsParser extends _Parser.Parser {
  constructor() {
    super(...arguments);
    _defineProperty(this, "priority", 40);
    _defineProperty(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return (0, _utils.parseAnyDigitsSigned)(dateString);
  }
  set(date, _flags, value) {
    return [(0, _index.constructFrom)(date, value * 1000), {
      timestampIsSet: true
    }];
  }
}
exports.TimestampSecondsParser = TimestampSecondsParser;